import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment'; // Aggiungi questo import

@Injectable({
  providedIn: 'root'
})
export class NoteService {

  private apiURL = environment.apiBaseUrl + '/note';

  constructor(private http: HttpClient) { }

  getNote(day: string): Observable<any> {
    const timestamp = new Date().getTime();

    return this.http.get<any>(`${this.apiURL}?day=${day}&timestamp=${timestamp}`);
  }

  update(noteData: any): Observable<any> {
    return this.http.put<any>(`${this.apiURL}/`, noteData);
  }
}
